// extracted by mini-css-extract-plugin
export var typingIndicator = "_nu-0";